import type { Citation, MessageType } from "@expert/shared-types";

import type { ExpertAssistMetadata } from "../../shared-types";

import { DEAD_AIR_TAG } from "../../shared-types";
import { CitationsHeader } from "./custom-messages/CitationsHeader";
import { DeadAirAssistHeader } from "./custom-messages/DeadAirAssist";
import { GuideRecommendationHeader } from "./custom-messages/GuideRecommendation";
import { SalesGuidanceHeader } from "./custom-messages/SalesGuidance";
import { SessionSummaryHeader } from "./custom-messages/SessionSummary";

export function MessageBubbleHeader({
    isLastProactiveMessage,
    type,
    metadata,
    citations,
    tag,
}: {
    isLastProactiveMessage: boolean;
    type: MessageType;
    metadata?: ExpertAssistMetadata;
    citations?: Citation[] | null;
    tag?: string;
}) {
    const { sessionSummary, guideRecommendation, salesGuidance } = metadata || {};
    if (type === "Proactive" && tag === DEAD_AIR_TAG) {
        return <DeadAirAssistHeader />;
    }

    if (type === "SessionSummary" && sessionSummary) {
        return <SessionSummaryHeader metadata={sessionSummary} isLastProactiveMessage={isLastProactiveMessage} />;
    }

    if (type === "GuideRecommendation" && guideRecommendation) {
        return <GuideRecommendationHeader guideTitle={guideRecommendation} />;
    }

    if (type === "SalesGuidance" && salesGuidance) {
        return <SalesGuidanceHeader title={salesGuidance.title} />;
    }

    if (citations && citations.length > 0) {
        return <CitationsHeader citations={citations} />;
    }
}
